import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'common-rate-advanced-markup-setting',
  imports: [],
  templateUrl: './rate-advanced-markup-setting.component.html',
  styleUrl: './rate-advanced-markup-setting.component.scss',
})
export class RateAdvancedMarkupSettingComponent implements OnInit {
  @Input() options: any;
  @Input() selectedMarkup: string;
  @Output() applyFilter = new EventEmitter();
  @Output() refreshRequested = new EventEmitter<void>();

  selectedOption: string;
  constructor(private router: Router) {}
  ngOnInit() {
    if (this.selectedMarkup) {
      this.selectedOption = this.selectedMarkup;
    }
  }

  selectOption(event: Event, option) {
    this.options.forEach((markup) => {
      markup.selected = false;
    });
    option.selected = true;
    event.preventDefault();
    event.stopPropagation();
    this.selectedOption = option?.value;
    this.applyFilter.emit(option?.value);
  }

  refreshMarkupOptions() {
    this.refreshRequested.emit();
  }

  redirect() {
    window.open('/settings/office-settings#markupsettings', '_blank');
  }

  clearSelection(event: Event): void {
    if (this.selectedOption) {
      event.preventDefault();
      event.stopPropagation();
      this.selectedOption = '';
      this.applyFilter.emit('');
    }
  }
}
